export const Column1 = [
  {
    // title: `${f('car')} ${f('insurance')}`,
    title: 'Car Insurance',
    link: '/car-insurance',
  },
  {
    title: `Home Insurance`,
    link: '/home-insurance',
  },
  {
    title: `Health Insurance`,
    link: '/health-insurance',
  },
  {
    title: `Life Insurance`,
    link: '/life-insurance',
  },
  {
    title: `Travel Insurance`,
    link: '/travel-insurance',
  },
  {
    title: `Business Insurance`,
    link: '/business-insurance',
  },
  {
    title: `Bike Insurance`,
    link: '/bike-insurance',
  },
];

export const Column2 = [
  {
    title: 'RSA',
    link: '/rsa-insurance',
  },
  {
    title: 'AXA',
    link: '/axa-insurance',
  },
  {
    title: 'OMAN',
    link: '/oman-insurance-quotes',
  },
  {
    title: 'noorTakaful',
    link: '/noor-takaful-quotes',
  },
  {
    title: 'NGI',
    link: '/ngi-deals',
  },
];

export const Column3 = [
  {
    title: 'companies',
    link: '/companies',
  },
  {
    title: 'coverage',
    link: '/coverage',
  },
  {
    title: 'comparison',
    link: '/what-can-you-expect-to-receive-from-us',
  },
  {
    title: 'discounts',
    link: '/further-discount-from-car-insurance-quotes',
  },
];

export const Column4 = [
  {
    title: 'ourStory',
    link: '/our-story',
  },
  {
    title: 'leadership',
    link: '/leadership',
  },
  {
    title: 'contactUs',
    link: '/contact-us',
  },
  {
    title: 'sitemap',
    link: '/sitemap',
  },
  {
    title: 'privacy',
    link: '/privacy',
  },
  {
    title: 'media',
    link: '/media',
  },
];

export const Column5 = [
  {
    title: 'eBooks',
    link: '/blog/ebooks',
  },
  {
    title: 'blogs',
    link: '/blogs',
  },
  {
    title: 'CEOBlog',
    link: '/ceosblog',
  },
  {
    title: 'knowYourInsurance',
    link: '/blog/know-your-insurance',
  },
  {
    title: 'askTheExpert',
    link: '/blog/ask-the-expert',
  },
  {
    title: 'FAQ',
    link: '/faq',
  },
];
